module.exports = __webpack_public_path__ + "static/media/loading.628c0d27.gif";